import type { IconProps } from './../../models/icon';

export function DealIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M4.70129 7.31294L0.939453 5.28839L0.939477 13.4791L10.1057 19.7276C11.2906 20.5354 12.853 20.5203 14.0221 19.6901L22.9753 13.439V4.51202L18.3367 7.01936L14.8511 6.64641C13.571 6.50946 12.2906 6.85778 11.2596 7.61505C11.2354 7.61505 11.212 7.60622 11.1936 7.5905C10.329 6.85278 9.18034 6.53744 8.05918 6.73156L4.70129 7.31294Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M0.939941 5.28839L4.70179 7.31295L8.05967 6.73156C9.19319 6.53529 10.3548 6.85977 11.2226 7.61504"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M19.3413 15.9127L14.0226 19.69C12.8535 20.5204 11.2911 20.5353 10.1062 19.7277L0.939941 13.4791"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M22.9754 13.439L19.212 16.0106L13.3729 11.2958L11.225 12.859C10.3517 13.4946 9.13165 13.3234 8.46706 12.4719C7.80399 11.6223 7.93191 10.4004 8.75655 9.70655L10.993 7.82486C12.0649 6.92299 13.4583 6.49739 14.8511 6.64643L18.3367 7.01936L22.9754 4.51202"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.7"
        d="M13.374 11.3086C14.7791 12.5604 16.7717 11.9218 17.5125 10.8999"
      />
    </svg>
  );
}
